import React from 'react';

const AppLoader = () => {
    return (
        <>
            <div className={"d-flex flex-column align-items-center justify-content-center spinner-flux"}>
                <div className={"loader-fluxer"}></div>
            </div>
        </>
    );
};

export default AppLoader;
